
<app-common-header></app-common-header>
<br />
<br />
<div class="container">
    <div class="row">
        <div class="col-md-9">
            <h1>{{pageheadername}} </h1> 
            <br />
            <h4  class="pageheading3 {{this.pageheadername.indexOf('Edit') > -1 ? 'username' :'' }}  {{this.Status == 'Archived' ? 'pending' : this.Status == 'Active' ? 'active' : this.Status == 'Suspended' ? 'suspend' :'inactive' }}" style="text-transform:capitalize;line-height: 1;">
              {{this.Status}}
            </h4>
        </div>
          
    </div>
    <div class="row">
        <div class="col-md-12">
            <form (ngSubmit)="AddEditPromoCode(managerMaintenanceForm.value)" [formGroup]="managerMaintenanceForm" role="form" novalidate autocomplete="false">
              <div class="row mt-3">
            
                <div class="col-md-6">
                  <label for="userId" class="control-label">Promo Code</label>
                  <input id="PromoCode" type="text"(focusout)="Generatelink()" (blur)="ChnagePromo(this)" class="form-control" formControlName="PromoCode"  />
                  <mat-error *ngFor="let validation of account_validation_messages.PromoCode">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('PromoCode').hasError(validation.type) && (managerMaintenanceForm.get('PromoCode').dirty || managerMaintenanceForm.get('PromoCode').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">Promo Code Description</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="PromoCodeDescription"
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.PromoCodeDescription">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('PromoCodeDescription').hasError(validation.type) && (managerMaintenanceForm.get('PromoCodeDescription').dirty || managerMaintenanceForm.get('PromoCodeDescription').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>
          
              <div class="row mt-3">
                <div class="col-md-6">
                  <label for="userId" class="control-label">Start Date</label>
                  <!-- <input
                    type="text"
                    class="form-control"
                    formControlName="StartDate"
                    id="StartDate"
                    (keydown.space)="$event.preventDefault()"
                    ng-pattern="/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/"
                  /> -->
                  <my-date-picker (ngModelChange)="minDate" formControlName="StartDate"  class="admindate date-format"  [options]="myDatePickerOptions" id ="StartDate"
                   placeholder = "MM/DD/YYYY" required></my-date-picker>
             
                  <mat-error *ngFor="let validation of account_validation_messages.StartDate">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('StartDate').hasError(validation.type) && (managerMaintenanceForm.get('StartDate').dirty || managerMaintenanceForm.get('StartDate').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">End Date</label>
                  <!-- <input
                    type="text"
                    class="form-control"
                    formControlName="EndDate"
                    id="EndDate"
                    (keydown.space)="$event.preventDefault()"
                    ng-pattern="/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/"
                  /> -->
                  <my-date-picker (ngModelChange)="maxDate" formControlName="EndDate"  class="date-format"  [options]="myDatePickerOptions" id ="EndDate"
                   placeholder = "MM/DD/YYYY" required></my-date-picker>
                  <mat-error *ngFor="let validation of account_validation_messages.EndDate">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('EndDate').hasError(validation.type) && (managerMaintenanceForm.get('EndDate').dirty || managerMaintenanceForm.get('EndDate').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <input type="checkbox" class="example-margin mat-checkbox mat-accent"
                  (click)="ChangeAffilateCheck($event)"
                  formControlName="IsAffiliate"
                  />
                  
                  &nbsp; <label for="IsAffiliate" class="control-label">IsAffiliate</label>

                </div>
             
             
        
              </div>

              <div class="row mt-3">
                <div class="col-md-6" *ngIf="ShowAffilateField">


                  
                 
                  <label for="userId" class="control-label">Affiliate</label>
                  <!-- <input
                    type="text"
                    class="form-control"
                    formControlName="Affiliate"
                  /> -->
                  <ng-select  [items]="AffiliateList" bindLabel="AffiliateName"
                  bindValue="_id" placeholder="Select" [searchable]="false" [clearable]="false"
                  id="Affiliate" (change)="Generatelink()"
                  formControlName="Affiliate">
                  </ng-select>
                  <mat-error *ngFor="let validation of account_validation_messages.Affiliate">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Affiliate').hasError(validation.type) && (managerMaintenanceForm.get('Affiliate').dirty || managerMaintenanceForm.get('Affiliate').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                 
                </div>
                <div class="col-md-6">

                  <label *ngIf="ShowAffilateField"  for="userId" class="control-label">Affiliate Link</label>
                  <label *ngIf="!ShowAffilateField"  for="userId" class="control-label">Promo Link</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="AffiliateLink"
                    readonly
                    disabled="disabled"
                    style="cursor: pointer;"
                    
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.AffiliateLink">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('AffiliateLink').hasError(validation.type) && (managerMaintenanceForm.get('AffiliateLink').dirty || managerMaintenanceForm.get('AffiliateLink').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                  <!-- <button type="button" (click)="copyText()" class="btn btn-secondary" data-toggle="tooltip" data-placement="top" title="Copied!">
                    Copied! 
                  </button> -->

                  <a style="margin-top: -34px;" title="Affiliate Link" data-toggle="tooltip" data-placement="top" title="Copied!" class="pull-right"(click)="copyText()"> <img class="" style="cursor: pointer ;background: #0fd873;  display: inline-block;
                    background: #2191fb;
                    text-align: center;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    padding: 4px;
                  
                    cursor: pointer;" src="assets/images/link-icon.svg" /></a>

                  <!-- <button type="button" (click)="copyText()">Click to copy</button> -->
               
                </div>

              </div>
           
              <div class="pull-right mt-2">
                <!-- <button
                  class="mr-2 mt-0 btn sectbtn brdrRadius"
                  (click)="AddEditAffilations()"
                >
                  Save
                </button> -->
                <button type="submit"  [disabled]="!managerMaintenanceForm.valid" class="mr-2 mt-0 btn sectbtn brdrRadius " >Save</button>

              </div>
            </form>
            <!-- <input matInput [(ngModel)]="data.animal"> -->
        </div>
    </div>
</div>
<ng-template #SuccessModel>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
      <h4
      class="utility-modal-title font20 text-center text-uppercase"
    
    >
    {{title}}
    </h4> 
   
    </div>
  </div>
  <div class="modal-body pt-0" style="text-align: center;">

    <p class="utility-sub-title font20">
    {{msg}}
    </p>
   
    <button type="button"  class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="modalRef.hide()" >OK</button>

  </div>
</ng-template>


  
  
